// 合計ナンプレ**固有**の設定（localStorage 永続）。
//
// ポータル横断の設定（音量・ミュート・BGM・言語）は
// [platform/net/settings.ts](@/platform/net/settings) が持つ。ここにあるのは
// 「このゲームでしか意味を持たない」項目だけ。所属の決め方は CLAUDE.md の
// 「設定は所属で2つに分かれる」を参照。
//
// キーは `pipes.*`（＝`game_key` と同じ文字列）。データ削除が接頭辞で掃くので、
// ここに増やしたぶんは自動で消える対象になる。
//
// ⏳ **いまは項目ゼロ**（最小形）。⚠️ 空でもスライスは置いておく——
//   registry に載っていないと、後から項目を足したときに**同期の配線だけ忘れる**。
import type { GameSettingsSlice } from '@/platform/net/settings';
import { GAME_KEY } from '../gameKey';

export const GAME_SETTINGS_DEFAULTS = {} as const;

/** このゲームの設定を既定値へ戻す。⏳ 項目が無いので今は何もしない。 */
export function resetGameSettings(): void {
  // 項目を足したらここにも書く（`reset` から呼ばれる）。
}

/**
 * サーバー同期用のスライス。`registry.ts` に載せると
 * `/api/settings` の `games.<gameKey>` として自動で往復するようになる。
 */
export const pipesSettingsSlice: GameSettingsSlice = {
  gameKey: GAME_KEY,
  read: () => ({}),
  apply: () => {
    // 項目を足したらここで受ける。
  },
  reset: resetGameSettings,
};
